import { ChangeEvent, FC } from 'react';
import { useField } from 'formik';
import { IFieldProps } from '../../';
import RelationSelectBox from 'src/Controls/RelationSelectBox';

interface IRelationFieldProps extends IFieldProps {
	relation: any;
	allowAdd?: boolean;
}

const RelationField: FC<IRelationFieldProps> = (props) => {
	const { name, setData, relation, ...otherProps } = props;
	const [inputProps, meta, helpers] = useField(name);

	/** Обработчик смены значения поля */
	const onChangeValueHandler = (value: any) => {
		helpers.setTouched(true);
		helpers.setValue(value, true);
		helpers.setError(undefined);

		!!setData &&
			setData((data: any) => {
				return { ...data, [name]: value };
			});
	};

	/** Обработчик установки touched в Formik */
	const setTouchedHandler = (value: boolean, shouldValidate?: boolean) => {
		helpers.setTouched(value, shouldValidate);
		if (value && meta.value) {
			helpers.setError(undefined);
		}
	};

	return (
		<RelationSelectBox
			{...otherProps}
			{...meta}
			{...inputProps}
			relation={relation}
			setTouched={setTouchedHandler}
			onChangeValue={onChangeValueHandler}
		/>
	);
};

export default RelationField;
